import React, { Component } from 'react'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import LocaleUtils from 'react-day-picker/moment'
import Navbar from './Navbar'
import moment from 'moment'
// Make sure moment.js has the required locale data

let availableLocalesForBus = [
  { locale: 'sv' },
  { locale: 'fi' },
  { locale: 'en', mapTo: 'en-gb' },
  { locale: 'dk', mapTo: 'da' },
  { locale: 'no', mapTo: 'sv' }
]
availableLocalesForBus.forEach(locale => {
  let useLocale = locale.mapTo || locale.locale
  require('moment/locale/' + useLocale)
})

class WrappedDayPicker extends Component {
  getSelectedLocale() {
    const { selectedLocale } = this.props
    return availableLocalesForBus.reduce((acc, locale) => {
      let useLocale = locale.mapTo || locale.locale
      if (locale.locale === selectedLocale) {
        acc = useLocale
      }
      return acc
    }, null)
  }

  handleDayClick(day) {
    let date = moment(day).format('YYYY-MM-DD')
    const { path, signals } = this.props
    signals.forms.fieldChanged({
      field: path,
      value: date,
      touched: true
    })
  }

  getModifiers() {
    const { field } = this.props
    if (field.value && field.value.length > 0) {
      let selectedDay = moment(field.value)
      return {
        selected: day => DateUtils.isSameDay(selectedDay, day)
      }
    }
  }

  touchEnd(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  render() {
    const { field, hasFocus } = this.props
    if (field.type !== 'date' || !hasFocus) {
      return null
    }
    let selectedDay = new Date()
    if (field.value && field.value.length > 0) {
      selectedDay = moment(field.value).toDate()
    }

    return (
      <div
        onTouchEnd={e => this.touchEnd(e)}
        style={{
          position: 'absolute',
          zIndex: 1000,
          top: 50,
          border: '1px solid #ccc',
          backgroundColor: '#fff'
        }}>
        <DayPicker
          navbarElement={<Navbar />}
          initialMonth={selectedDay}
          modifiers={{
            selected: day => DateUtils.isSameDay(selectedDay, day)
          }}
          onDayClick={this.handleDayClick.bind(this)}
          onDayTouchStart={this.handleDayClick.bind(this)}
          localeUtils={LocaleUtils}
          locale={this.getSelectedLocale()}
        />
      </div>
    )
  }
}

export default WrappedDayPicker



// WEBPACK FOOTER //
// ./src/components/inputs/wrappedDayPicker.js